var __defProp = Object.defineProperty;
var __typeError = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet = (obj, member, value, setter) => (__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), method);
var _ProductCardLink_instances, setImageSrcset_fn, _fetchProductPageHandler, _navigateToURL, _ProductCard_instances, preloadNextPreviewImage_fn, _handleQuickAdd, _handleProductSelect, updateOverflowList_fn, updateProductUrl_fn, isUnavailableVariantSelected_fn, toggleAddToCartButton_fn, updateVariantImages_fn, _previousSlideIndex, _handleSlideshowSelect, _resetVariant, _SwatchesVariantPickerComponent_instances, handleCardProductSelect_fn;
import { OverflowList } from "@theme/overflow-list";
import VariantPicker from "@theme/variant-picker";
import { ProductComponent } from "@theme/view-event-elements";
import { debounce, isDesktopBreakpoint, mediaQueryLarge, yieldToMainThread } from "@theme/utilities";
import { SlideshowSelectEvent } from "@theme/events";
import { morph } from "@theme/morph";
import { StandardEvents, ProductSelectEvent } from "@shopify/events";
class ProductCardLink extends ProductComponent {
  constructor() {
    super(...arguments);
    __privateAdd(this, _ProductCardLink_instances);
  }
  get productTransitionEnabled() {
    return this.getAttribute("data-product-transition") === "true";
  }
  get featuredMediaUrl() {
    return this.getAttribute("data-featured-media-url");
  }
  /**
   * Handles the click event for view transitions.
   * @param {Event} event
   */
  handleViewTransition(event) {
    if (event.defaultPrevented) return;
    if (event.target instanceof Element) {
      const interactiveElement = event.target.closest('button, input, label, select, [tabindex="1"]');
      if (interactiveElement) return;
    }
    if (!this.productTransitionEnabled) return;
    const { cardGallery } = this.refs;
    if (!cardGallery || !cardGallery.hasAttribute("data-view-transition-to-main-product")) return;
    const { imagesToTransition } = this.refs;
    const activeImage = (imagesToTransition == null ? void 0 : imagesToTransition.find(
      (image) => {
        var _a;
        return ((_a = image.closest("slideshow-slide")) == null ? void 0 : _a.getAttribute("aria-hidden")) === "false";
      }
    )) || (imagesToTransition == null ? void 0 : imagesToTransition[imagesToTransition.length - 1]);
    if (activeImage instanceof HTMLImageElement) __privateMethod(this, _ProductCardLink_instances, setImageSrcset_fn).call(this, activeImage);
    cardGallery.setAttribute("data-view-transition-type", "product-image-transition");
    cardGallery.setAttribute("data-view-transition-triggered", "true");
  }
}
_ProductCardLink_instances = /* @__PURE__ */ new WeakSet();
setImageSrcset_fn = function(image) {
  if (!this.featuredMediaUrl) return;
  const currentImageUrl = new URL(image.currentSrc);
  const currentImageRawUrl = currentImageUrl.host + currentImageUrl.pathname;
  if (!this.featuredMediaUrl.includes(currentImageRawUrl)) {
    const imageFade = image.animate([{ opacity: 0.8 }, { opacity: 1 }], {
      duration: 125,
      easing: "ease-in-out"
    });
    imageFade.onfinish = () => {
      var _a;
      image.srcset = (_a = this.featuredMediaUrl) != null ? _a : "";
    };
  }
};
if (!customElements.get("product-card-link")) {
  customElements.define("product-card-link", ProductCardLink);
}
class ProductCard extends ProductCardLink {
  constructor() {
    super(...arguments);
    __privateAdd(this, _ProductCard_instances);
    this.selectionGeneration = 0;
    this.selectionDetached = false;
    __publicField(this, "requiredRefs", ["productCardLink"]);
    __privateAdd(this, _fetchProductPageHandler, () => {
      var _a;
      (_a = this.refs.quickAdd) == null ? void 0 : _a.fetchProductPage(this.productPageUrl);
    });
    __privateAdd(this, _navigateToURL, (event, url) => {
      const shouldOpenInNewTab = event instanceof MouseEvent && (event.metaKey || event.ctrlKey || event.shiftKey || event.button === 1);
      if (shouldOpenInNewTab) {
        event.preventDefault();
        window.open(url.href, "_blank");
        return;
      } else {
        window.location.href = url.href;
      }
    });
    __privateAdd(this, _handleQuickAdd, () => {
      this.removeEventListener("pointerenter", __privateGet(this, _fetchProductPageHandler));
      this.removeEventListener("focusin", __privateGet(this, _fetchProductPageHandler));
      if (isDesktopBreakpoint()) {
        this.addEventListener("pointerenter", __privateGet(this, _fetchProductPageHandler));
        this.addEventListener("focusin", __privateGet(this, _fetchProductPageHandler));
      }
    });
    __privateAdd(this, _handleProductSelect, (event) => {
      var _a, _b;
      if (!event.promise || typeof event.promise.then !== "function" || this.selectionDetached) return;
      if (event.target instanceof Element && event.target.closest("product-card") && event.target.closest("product-card") !== this) return;
      const generation = ++this.selectionGeneration;
      const { optionValueId } = (_a = event.detail) != null ? _a : {};
      if (optionValueId && event.target !== this.variantPicker) {
        (_b = this.variantPicker) == null ? void 0 : _b.updateSelectedOption(optionValueId);
      }
      return event.promise.then(({ detail }) => {
        if (this.selectionDetached || generation !== this.selectionGeneration) return;
        var _a2, _b2;
        if (!(detail == null ? void 0 : detail.html)) return;
        const { html } = detail;
        this.updatePrice(html);
        __privateMethod(this, _ProductCard_instances, isUnavailableVariantSelected_fn).call(this, html);
        __privateMethod(this, _ProductCard_instances, updateProductUrl_fn).call(this, html);
        (_a2 = this.refs.quickAdd) == null ? void 0 : _a2.fetchProductPage(this.productPageUrl);
        if (event.target !== this.variantPicker) {
          (_b2 = this.variantPicker) == null ? void 0 : _b2.updateVariantPicker(html);
        }
        __privateMethod(this, _ProductCard_instances, updateVariantImages_fn).call(this);
        __privateSet(this, _previousSlideIndex, null);
        this.removeAttribute("data-no-swatch-selected");
        __privateMethod(this, _ProductCard_instances, updateOverflowList_fn).call(this);
      }).catch((error) => {
        if ((error == null ? void 0 : error.name) !== "AbortError") console.warn("[product-card] Event promise rejected:", error);
      });
    });
    __privateAdd(this, _previousSlideIndex, null);
    __privateAdd(this, _handleSlideshowSelect, (event) => {
      if (event.detail.userInitiated) {
        __privateSet(this, _previousSlideIndex, event.detail.index);
      }
    });
    __privateAdd(this, _resetVariant, () => {
      var _a, _b;
      const { slideshow } = this.refs;
      if (!slideshow) return;
      if ((_a = this.variantPicker) == null ? void 0 : _a.selectedOption) {
        const id = this.variantPicker.selectedOption.dataset.optionMediaId;
        if (id) {
          slideshow.select({ id }, void 0, { animate: false });
          return;
        }
      }
      const initialSlide = slideshow.initialSlide;
      const slideId = initialSlide == null ? void 0 : initialSlide.getAttribute("slide-id");
      if (initialSlide && ((_b = slideshow.slides) == null ? void 0 : _b.includes(initialSlide)) && slideId) {
        slideshow.select({ id: slideId }, void 0, { animate: false });
        return;
      }
      slideshow.previous(void 0, { animate: false });
    });
    __publicField(this, "navigateToProduct", (event) => {
      if (!(event.target instanceof Element)) return;
      if (this.hasAttribute("data-no-navigation")) return;
      const interactiveElement = event.target.closest('button, input, label, select, [tabindex="1"]');
      if (interactiveElement) {
        return;
      }
      const link = this.refs.productCardLink;
      if (!link.href) return;
      const linkURL = new URL(link.href);
      const productCardAnchor = link.getAttribute("id");
      if (!productCardAnchor) return;
      const infiniteResultsList = this.closest('results-list[infinite-scroll="true"]');
      if (!window.Shopify.designMode && infiniteResultsList) {
        const url = new URL(window.location.href);
        const parent = this.closest("li");
        url.hash = productCardAnchor;
        if (parent && parent.dataset.page) {
          url.searchParams.set("page", parent.dataset.page);
        }
        yieldToMainThread().then(() => {
          history.replaceState({}, "", url.toString());
        });
      }
      const targetLink = event.target.closest("a");
      if (!targetLink) {
        __privateGet(this, _navigateToURL).call(this, event, linkURL);
      }
    });
    __publicField(this, "resetVariant", debounce(__privateGet(this, _resetVariant), 100));
  }
  get productPageUrl() {
    return this.refs.productCardLink.href;
  }
  /**
   * Gets the currently selected variant ID from the product card
   * @returns {string | null} The variant ID or null if none selected
   */
  getSelectedVariantId() {
    const checkedInput = (
      /** @type {HTMLInputElement | null} */
      this.querySelector('input[type="radio"]:checked[data-variant-id]')
    );
    return (checkedInput == null ? void 0 : checkedInput.dataset.variantId) || null;
  }
  /**
   * Gets the product card link element
   * @returns {HTMLAnchorElement | null} The product card link or null
   */
  getProductCardLink() {
    return this.refs.productCardLink || null;
  }
  connectedCallback() {
    super.connectedCallback();
    this.selectionDetached = false;
    const link = this.refs.productCardLink;
    if (!(link instanceof HTMLAnchorElement)) throw new Error("Product card link not found");
    __privateGet(this, _handleQuickAdd).call(this);
    this.addEventListener(StandardEvents.productSelect, __privateGet(this, _handleProductSelect));
    this.addEventListener(SlideshowSelectEvent.eventName, __privateGet(this, _handleSlideshowSelect));
    mediaQueryLarge.addEventListener("change", __privateGet(this, _handleQuickAdd));
    this.addEventListener("click", this.navigateToProduct);
    clearTimeout(this.previewTimer);
    this.previewTimer = setTimeout(() => {
      if (this.selectionDetached) return;
      var _a;
      if ((_a = this.refs.slideshow) == null ? void 0 : _a.isNested) {
        __privateMethod(this, _ProductCard_instances, preloadNextPreviewImage_fn).call(this);
      }
    });
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.selectionDetached = true;
    ++this.selectionGeneration;
    clearTimeout(this.previewTimer);
    this.resetVariant.cancel();
    this.removeEventListener(StandardEvents.productSelect, __privateGet(this, _handleProductSelect));
    this.removeEventListener(SlideshowSelectEvent.eventName, __privateGet(this, _handleSlideshowSelect));
    mediaQueryLarge.removeEventListener("change", __privateGet(this, _handleQuickAdd));
    this.removeEventListener("pointerenter", __privateGet(this, _fetchProductPageHandler));
    this.removeEventListener("focusin", __privateGet(this, _fetchProductPageHandler));
    this.removeEventListener("click", this.navigateToProduct);
  }
  /**
   * Updates the DOM with a new price.
   * @param {Document} html - The parsed HTML document with updated variant data.
   */
  updatePrice(html) {
    const priceContainer = this.querySelectorAll("product-price [ref='priceContainer']")[1];
    const newPriceElement = html.querySelector("product-price [ref='priceContainer']");
    if (newPriceElement && priceContainer) {
      morph(priceContainer, newPriceElement);
    }
  }
  /**
   * Gets all variant inputs.
   * @returns {NodeListOf<HTMLInputElement>} All variant input elements.
   */
  get allVariants() {
    return this.querySelectorAll("input[data-variant-id]");
  }
  /**
   * Gets the variant picker component.
   * @returns {VariantPicker | null} The variant picker component.
   */
  get variantPicker() {
    return this.querySelector("swatches-variant-picker-component");
  }
  /**
   * Previews a variant.
   * @param {string} id - The id of the variant to preview.
   */
  previewVariant(id) {
    const { slideshow } = this.refs;
    if (!slideshow) return;
    this.resetVariant.cancel();
    slideshow.select({ id }, void 0, { animate: false });
  }
  /**
   * Previews the next image.
   * @param {PointerEvent} event - The pointer event.
   */
  previewImage(event) {
    if (event.pointerType !== "mouse") return;
    const { slideshow } = this.refs;
    if (!slideshow) return;
    this.resetVariant.cancel();
    if (__privateGet(this, _previousSlideIndex) != null && __privateGet(this, _previousSlideIndex) > 0) {
      slideshow.select(__privateGet(this, _previousSlideIndex), void 0, { animate: false });
    } else {
      slideshow.next(void 0, { animate: false });
      clearTimeout(this.previewTimer);
      this.previewTimer = setTimeout(() => {
        if (!this.selectionDetached) __privateMethod(this, _ProductCard_instances, preloadNextPreviewImage_fn).call(this);
      });
    }
  }
  /**
   * Resets the image to the variant image.
   * @param {PointerEvent} event - The pointer event.
   */
  resetImage(event) {
    if (event.pointerType !== "mouse") return;
    const { slideshow } = this.refs;
    if (!this.variantPicker) {
      if (!slideshow) return;
      slideshow.previous(void 0, { animate: false });
    } else {
      __privateGet(this, _resetVariant).call(this);
    }
  }
}
_fetchProductPageHandler = /* @__PURE__ */ new WeakMap();
_navigateToURL = /* @__PURE__ */ new WeakMap();
_ProductCard_instances = /* @__PURE__ */ new WeakSet();
preloadNextPreviewImage_fn = function() {
  var _a, _b, _c, _d, _e;
  const currentSlide = (_c = (_a = this.refs.slideshow) == null ? void 0 : _a.slides) == null ? void 0 : _c[(_b = this.refs.slideshow) == null ? void 0 : _b.current];
  (_e = (_d = currentSlide == null ? void 0 : currentSlide.nextElementSibling) == null ? void 0 : _d.querySelector('img[loading="lazy"]')) == null ? void 0 : _e.removeAttribute("loading");
};
_handleQuickAdd = /* @__PURE__ */ new WeakMap();
_handleProductSelect = /* @__PURE__ */ new WeakMap();
updateOverflowList_fn = function() {
  const overflowList = this.querySelector("swatches-variant-picker-component overflow-list");
  const isActiveOverflowList = (overflowList == null ? void 0 : overflowList.querySelector('[slot="overflow"]')) ? true : false;
  if (!overflowList || !isActiveOverflowList) return;
  requestAnimationFrame(() => {
    overflowList.dispatchEvent(
      new CustomEvent("reflow", {
        bubbles: true,
        detail: {}
      })
    );
  });
};
updateProductUrl_fn = function(html) {
  var _a;
  const responseProductCard = html.querySelector("product-card");
  const anchorElement = responseProductCard == null ? void 0 : responseProductCard.querySelector("a");
  const featuredMediaUrl = responseProductCard == null ? void 0 : responseProductCard.getAttribute("data-featured-media-url");
  if (featuredMediaUrl) {
    this.setAttribute("data-featured-media-url", featuredMediaUrl);
  }
  if (anchorElement instanceof HTMLAnchorElement) {
    if (((_a = anchorElement.getAttribute("href")) == null ? void 0 : _a.trim()) === "") return;
    const productUrl = anchorElement.href;
    const { productCardLink, productTitleLink, cardGalleryLink } = this.refs;
    productCardLink.href = productUrl;
    if (cardGalleryLink instanceof HTMLAnchorElement) {
      cardGalleryLink.href = productUrl;
    }
    if (productTitleLink instanceof HTMLAnchorElement) {
      productTitleLink.href = productUrl;
    }
  }
};
isUnavailableVariantSelected_fn = function(html) {
  const allVariants = (
    /** @type {NodeListOf<HTMLInputElement>} */
    html.querySelectorAll("input:checked")
  );
  for (const variant of allVariants) {
    __privateMethod(this, _ProductCard_instances, toggleAddToCartButton_fn).call(this, variant.dataset.optionAvailable === "true");
  }
};
toggleAddToCartButton_fn = function(enable) {
  const addToCartButton = this.querySelector(".add-to-cart__button button");
  if (addToCartButton instanceof HTMLButtonElement) {
    addToCartButton.disabled = !enable;
  }
};
updateVariantImages_fn = function() {
  var _a, _b;
  const { slideshow } = this.refs;
  if (!((_a = this.variantPicker) == null ? void 0 : _a.selectedOption)) {
    return;
  }
  const selectedImageId = (_b = this.variantPicker) == null ? void 0 : _b.selectedOption.dataset.optionMediaId;
  if (slideshow && selectedImageId) {
    const { slides = [] } = slideshow.refs;
    for (const slide of slides) {
      if (slide.getAttribute("variant-image") == null) continue;
      slide.hidden = slide.getAttribute("slide-id") !== selectedImageId;
    }
    slideshow.select({ id: selectedImageId }, void 0, { animate: false });
  }
};
_previousSlideIndex = /* @__PURE__ */ new WeakMap();
_handleSlideshowSelect = /* @__PURE__ */ new WeakMap();
_resetVariant = /* @__PURE__ */ new WeakMap();
if (!customElements.get("product-card")) {
  customElements.define("product-card", ProductCard);
}
class SwatchesVariantPickerComponent extends VariantPicker {
  constructor() {
    super(...arguments);
    __privateAdd(this, _SwatchesVariantPickerComponent_instances);
    this.cardSelectionGeneration = 0;
    this.cardSelectionDetached = false;
    this.cardSelectionHandler = __privateMethod(this, _SwatchesVariantPickerComponent_instances, handleCardProductSelect_fn).bind(this);
  }
  connectedCallback() {
    super.connectedCallback();
    this.cardSelectionDetached = false;
    this.parentProductCard = this.closest("product-card");
    this.addEventListener(StandardEvents.productSelect, this.cardSelectionHandler);
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.cardSelectionDetached = true;
    ++this.cardSelectionGeneration;
    this.pendingVariantId = null;
    this.removeEventListener(StandardEvents.productSelect, this.cardSelectionHandler);
  }
  /**
   * Override the variantChanged method to handle unavailable swatches with available alternatives.
   * @param {Event} event - The variant change event.
   */
  variantChanged(event) {
    var _a, _b;
    if (!(event.target instanceof HTMLElement)) return;
    const isSwatchInput = event.target instanceof HTMLInputElement && ((_a = event.target.name) == null ? void 0 : _a.includes("-swatch"));
    const clickedSwatch = event.target;
    const availableCount = parseInt(clickedSwatch.dataset.availableCount || "0");
    const firstAvailableVariantId = clickedSwatch.dataset.firstAvailableOrFirstVariantId;
    if (isSwatchInput && availableCount > 0 && firstAvailableVariantId) {
      event.stopPropagation();
      this.updateSelectedOption(clickedSwatch);
      const productUrl = (_b = this.dataset.productUrl) == null ? void 0 : _b.split("?")[0];
      if (!productUrl) return;
      const url = new URL(productUrl, window.location.origin);
      url.searchParams.set("variant", firstAvailableVariantId);
      url.searchParams.set("section_id", "section-rendering-product-card");
      const requestUrl = url.href;
      this.pendingVariantId = firstAvailableVariantId;
      this.fetchUpdatedSection(requestUrl);
      return;
    }
    this.pendingVariantId = null;
    super.variantChanged(event);
  }
  /**
   * Shows all swatches.
   * @param {Event} [event] - The event that triggered the show all swatches.
   */
  showAllSwatches(event) {
    event == null ? void 0 : event.preventDefault();
    const { overflowList } = this.refs;
    if (overflowList instanceof OverflowList) {
      overflowList.showAll();
    }
  }
}
_SwatchesVariantPickerComponent_instances = /* @__PURE__ */ new WeakSet();
handleCardProductSelect_fn = function(event) {
  if (!event.promise || typeof event.promise.then !== "function" || this.cardSelectionDetached) return;
  const generation = ++this.cardSelectionGeneration;
  const intended = this.pendingVariantId;
  const parent = this.parentProductCard;
  return event.promise.then(({ detail }) => {
    var _a;
    if (this.cardSelectionDetached || generation !== this.cardSelectionGeneration || parent !== this.parentProductCard) return;
    if (intended && ((_a = detail == null ? void 0 : detail.resource) == null ? void 0 : _a.id) && this.parentProductCard instanceof ProductCard) {
      const currentUrl = new URL(this.parentProductCard.refs.productCardLink.href);
      currentUrl.searchParams.set("variant", String(detail.resource.id));
      this.parentProductCard.refs.productCardLink.href = currentUrl.toString();
    }
    this.pendingVariantId = null;
  }).catch((error) => {
    if (generation === this.cardSelectionGeneration) this.pendingVariantId = null;
    if ((error == null ? void 0 : error.name) !== "AbortError") console.warn("[product-card] Event promise rejected:", error);
  });
};
if (!customElements.get("swatches-variant-picker-component")) {
  customElements.define("swatches-variant-picker-component", SwatchesVariantPickerComponent);
}
export {
  ProductCard,
  ProductCardLink
};
